var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductGoose = function SvgProductGoose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 74.9111,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 65.9824,
    width: 7.14285,
    height: 14.6429,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 71.3398,
    width: 57.1428,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2144,
    y: 65.9824,
    width: 32.1428,
    height: 8.92857,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 62.4121,
    width: 42.8571,
    height: 9.28571,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1428 53.4824H36.0714V57.0541H28.9285V69.5541H28.9284V60.6251H19.9998V69.5541H14.6426V80.2683H21.7858V82.0538H60.1786V80.2683H71.7854V74.911H75.357V64.1967H69.9999V57.0541H52.1428V53.4824Z",
    fill: "#F09343"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 58.8398,
    width: 17.8571,
    height: 9.28571,
    fill: "#F09343"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 19.5547,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0713,
    y: 51.6973,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 55.2686,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6426,
    y: 67.7686,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 65.9824,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 78.4824,
    width: 7.14285,
    height: 1.78571,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 85.625,
    width: 46.4286,
    height: 1.78571,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 58.8398,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 30.2686,
    width: 8.92857,
    height: 1.78571,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 37.4121,
    width: 12.5,
    height: 1.78571,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 22.2324,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2856,
    y: 53.4824,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80.2676,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8574,
    y: 69.5547,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1426,
    y: 57.0547,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27.5898,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 26.6973,
    width: 1.78571,
    height: 28.5714,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 39.1973,
    width: 1.78571,
    height: 21.4286,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 58.8398,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 64.1973,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 69.5547,
    width: 32.1428,
    height: 1.78571,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 60.625,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 62.4121,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 74.9111,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3569,
    y: 64.1973,
    width: 1.78571,
    height: 10.7143,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 60.625,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 74.9111,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7144,
    y: 32.0547,
    width: 1.78571,
    height: 7.14285,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 25.8047,
    width: 16.0714,
    height: 31.25,
    fill: "#514E4E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 22.2324,
    width: 14.2857,
    height: 10.7143,
    fill: "#302E2E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 32.0547,
    width: 14.2857,
    height: 7.14285,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 21.3398,
    width: 14.2857,
    height: 10.7143,
    fill: "#514E4E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 32.0547,
    width: 14.2857,
    height: 5.35714,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 27.5898,
    width: 10.7143,
    height: 7.14285,
    fill: "#514E4E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 26.6973,
    width: 3.57143,
    height: 5.35714,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 26.6973,
    width: 1.78571,
    height: 1.78571,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 57.0547,
    width: 14.2857,
    height: 1.78571,
    fill: "#C47937"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 71.3398,
    width: 8.92857,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 80.2676,
    width: 8.92857,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 76.6973,
    width: 1.78571,
    height: 3.57143,
    fill: "#FFFEFD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 80.2676,
    width: 46.4286,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 67.7686,
    width: 30.3571,
    height: 1.78571,
    fill: "#C47937"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 80.2676,
    width: 33.9286,
    height: 1.78571,
    fill: "#C47937"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 83.8398,
    width: 46.4286,
    height: 1.78571,
    fill: "#BABABA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 78.4824,
    width: 7.14285,
    height: 1.78571,
    fill: "#C47937"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 69.5547,
    width: 7.14285,
    height: 1.78571,
    fill: "#C47937"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0713,
    y: 74.9111,
    width: 1.78571,
    height: 3.57143,
    fill: "#C47937"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 64.1973,
    width: 1.78571,
    height: 3.57143,
    fill: "#C47937"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 60.625,
    width: 1.78571,
    height: 3.57143,
    fill: "#C47937"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60.625,
    width: 3.57143,
    height: 5.35714,
    fill: "#C47937"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 65.9824,
    width: 1.78571,
    height: 3.57143,
    fill: "#C47937"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 82.0547,
    width: 46.4286,
    height: 1.78571,
    fill: "#EAEAEA"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 55.2686,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 73.125,
    width: 5.35714,
    height: 5.35714,
    fill: "#C47937"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 73.125,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 76.6973,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 22.2324,
    width: 1.78571,
    height: 4.46428,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 82.0547,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6426,
    y: 74.9111,
    width: 7.14285,
    height: 5.35714,
    fill: "#FFFEFD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80.2676,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 80.2676,
    width: 1.78571,
    height: 5.35714,
    fill: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 71.3398,
    width: 3.57143,
    height: 1.78571,
    transform: "rotate(90 68.2144 71.3398)",
    fill: "#C47937"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8574,
    y: 74.9111,
    width: 3.57143,
    height: 1.78571,
    fill: "#C47937"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 60.625,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 64.1973,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4287,
    y: 65.9824,
    width: 1.78571,
    height: 3.57143,
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8574,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0718,
    y: 50.8037,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 70 50.8037)",
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0718,
    y: 57.9473,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 70 57.9473)",
    fill: "black"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 49.0186,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 50.8037,
    width: 3.57143,
    height: 8.92857,
    fill: "#F7CE58"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2861,
    y: 52.5908,
    width: 3.57143,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 52.5908,
    width: 3.57143,
    height: 5.35714,
    fill: "#F7CE58"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 54.376,
    width: 1.78571,
    height: 1.78571,
    fill: "#C47937"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2861,
    y: 54.376,
    width: 3.57143,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50.8037,
    width: 3.57143,
    height: 8.92857,
    fill: "#F7CE58"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 3.57143,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 73.5718 49.0186)",
    fill: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 59.7334,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 3.57143,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 73.5718 59.7334)",
    fill: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 50.8037,
    width: 1.78571,
    height: 8.92857,
    fill: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 8.92857,
    transform: "matrix(-1 0 0 1 75.3574 50.8037)",
    fill: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8574,
    y: 56.1611,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    transform: "rotate(90 64.6431 52.5908)",
    fill: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    transform: "rotate(90 68.2144 52.5908)",
    fill: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 54.376,
    width: 3.57143,
    height: 1.78571,
    fill: "#B1923B"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8574,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0718,
    y: 50.8037,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 70.0005 50.8037)",
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0718,
    y: 57.9473,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 70.0005 57.9473)",
    fill: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5,
    y: 49.0186,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5005,
    y: 50.8037,
    width: 3.57143,
    height: 8.92857,
    fill: "#F09343"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2861,
    y: 52.5908,
    width: 3.57143,
    height: 5.35714,
    fill: "#F09343"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 52.5908,
    width: 3.57143,
    height: 5.35714,
    fill: "#F09343"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 54.376,
    width: 1.78571,
    height: 1.78571,
    fill: "white"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 54.376,
    width: 3.57143,
    height: 1.78571,
    fill: "#C47937"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0005,
    y: 50.8037,
    width: 3.57143,
    height: 8.92857,
    fill: "#F09343"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 3.57143,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 73.5718 49.0186)",
    fill: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5005,
    y: 59.7334,
    width: 3.57143,
    height: 1.78571,
    fill: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 3.57143,
    height: 1.78571,
    transform: "matrix(-1 0 0 1 73.5718 59.7334)",
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 50.8037,
    width: 1.78571,
    height: 8.92857,
    fill: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 1.78571,
    height: 8.92857,
    transform: "matrix(-1 0 0 1 75.3574 50.8037)",
    fill: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8574,
    y: 56.1611,
    width: 5.35714,
    height: 1.78571,
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6431,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    transform: "rotate(90 64.6431 52.5908)",
    fill: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 52.5908,
    width: 5.35714,
    height: 1.78571,
    transform: "rotate(90 68.2144 52.5908)",
    fill: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 54.376,
    width: 3.57143,
    height: 1.78571,
    fill: "#C47937"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6787,
    y: 18.6621,
    width: 25.8928,
    height: 3.57143,
    fill: "#0D0D0B"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 2.58984,
    width: 17.8571,
    height: 16.0714,
    fill: "#0D0D0B"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 4.375,
    width: 14.2857,
    height: 14.2857,
    fill: "#F09343"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0356,
    y: 3.125,
    width: 16.0714,
    height: 10.7143,
    fill: "#0D0D0B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProductGoose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/productGoose.513d7c5b.svg";
export { ForwardRef as ReactComponent };